export default __webpack_public_path__ + "static/media/21.49b621c5.jpg";